import { render, staticRenderFns } from "./GeneralTreeFolder.vue?vue&type=template&id=36b4c5e6&scoped=true"
import script from "./GeneralTreeFolder.vue?vue&type=script&lang=js"
export * from "./GeneralTreeFolder.vue?vue&type=script&lang=js"
import style0 from "./GeneralTreeFolder.vue?vue&type=style&index=0&id=36b4c5e6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b4c5e6",
  null
  
)

export default component.exports